import React, {  useState , useContext} from "react";
import genting2night from "../assets/genting_2nights.jpg";
import disney3night from "../assets/disney_3night.jpg";
import Royal3nights from "../assets/ovation_3night.jpg";
import genting3night from "../assets/genting_2nights.jpg";
// import disney5night from "../assets/disney_adventure_5night.jpg";
import princess5night from "../assets/princess_5night.jpg";
import royal5night from "../assets/ovation_3night.jpg";
import royalnv5night from "../assets/navigator_5nights_.jpg";
import royal8night from "../assets/ovation_3night.jpg";
import royallogo from "../assets/RCI_Brand_Logo_2-Line_Horiz_Navy_RGB.png";
import "../singapore.css";
import special1 from "../assets/singapor-malaysia.jpg"
import special2 from "../assets/• Singapore • Malaysia • Singapore.jpg"
import { Link } from "react-router-dom";

import { CurrencyContext } from "../components/CurrencyContext";

// const Linkdata = {
  
//    Nights2:{
//     INR:"https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=1-3&destinationtype=All&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
//     SGD:"https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=1-3&destinationtype=All&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
//     USD:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=1-3&destinationtype=All&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc"
//    },

//    Nights3:{
  
//   INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=1-3&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
//   SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=1-3&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
//   USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=1-3&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"  
//    },

//    Nights4:{
   
//   INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=4-6&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
//   SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=4-6&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
//   USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=4-6&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc" 
//    },

//   }
//    Nights8:{
//     INR:"https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=7-9&destinationtype=All&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
//     SGD:"https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=7-9&destinationtype=All&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
//     USD:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=7-9&destinationtype=All&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc"
//    }
  
//   }

const itinerariesData = {
  "2-nights": [
    {
      id: 1,
      title: "Genting Dream",
      // destination: "Singapore",
      cruiseLine: "StarDream Cruises",
      // price: 199,
      imageUrl: genting2night,
      links:{

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&CruiseLine=9289&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&CruiseLine=9289&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&CruiseLine=9289&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
      // isExclusive: false
    }
    // {
    //   id: 2,
    //   title: "Weekend Escape",
    //   destination: "Singapore - Thailand",
    //   cruiseLine: "Genting Dream",
    //   price: 249,
    //   imageUrl: "https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2070&auto=format&fit=crop",
    //   isExclusive: false
    // },

  ]
  ,
  "3-nights": [

    
    {
      id: 2,
      title: "Genting Dream",
      // destination: "High-Sea Sailing",
      cruiseLine: "StarDream Cruises",
      // price: 399,
      imageUrl: genting3night,
      // isExclusive: false
        links:{

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&CruiseLine=9289&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&CruiseLine=9289&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&CruiseLine=9289&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
    },
    {
      id: 3,
      title: "Ovation of the Seas",
      // destination: "Singapore - Thailand",
      cruiseLine: "Royal Caribbean",
      // price: 349,
      imageUrl: Royal3nights,
      // isExclusive: true,
      // savings: "Save 40%"
        links:{

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=1-3&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=1-3&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=1-3&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
    }
    ,
  {
      id: 4,
      title: "Navigator of the Seas",
      // destination: "High-Sea Experience",
      cruiseLine: "Royal Caribbean",
      // price: 699,
      imageUrl: royalnv5night,
      // isExclusive: false
        links:{

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=1-3&destinationtype=All&Ship=81&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=1-3&destinationtype=All&Ship=81&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=1-3&destinationtype=All&Ship=81&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
    },

    {
      id: 5,
      title: "Disney Adventure",
      // destination: "Singapore - Malaysia",
      cruiseLine: "Disney Cruise Line",
      // price: 299,
      imageUrl: disney3night,
      // isExclusive: true,
      // savings: "Save 30%"
        links:{

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=1-3&destinationtype=All&ship=15406&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=1-3&destinationtype=All&ship=15406&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=1-3&destinationtype=All&ship=15406&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
    }
  ],
  "4-nights": [
    {
      id: 6,
      title: "Disney Adventure",
      // destination: "Singapore - Thailand",
      cruiseLine: "Disney Cruise Line",
      // price: 649,
      imageUrl:disney3night,
      // isExclusive: false
        links:{

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=4-6&destinationtype=All&Ship=15406&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=4-6&destinationtype=All&Ship=15406&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=4-6&destinationtype=All&Ship=15406&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
    },
    {
      id: 7,
      title: "Ovation of the Seas",
      // destination: "High-Sea Experience",
      cruiseLine: "Royal Caribbean",
      // price: 699,
      imageUrl: royal5night,
        links:{

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=4-6&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=4-6&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=4-6&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
      // isExclusive: false
    },
    {
      id: 8,
      title: "Navigator of the Seas",
      // destination: "High-Sea Experience",
      cruiseLine: "Royal Caribbean",
      // price: 699,
      imageUrl: royalnv5night,
        links:{

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=4-6&destinationtype=All&Ship=81&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=4-6&destinationtype=All&Ship=81&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=4-6&destinationtype=All&Ship=81&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
      // isExclusive: false
    }
  ],
  "5-nights": [
    {
      id: 9,
      title: "Disney Adventure",
      // destination: "Singapore - Thailand",
      cruiseLine: "Disney Cruise Line",
      // price: 649,
      imageUrl:disney3night,
        links:{

   INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=4-6&destinationtype=All&Ship=15406&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=4-6&destinationtype=All&Ship=15406&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=4-6&destinationtype=All&Ship=15406&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"    
      }
      // isExclusive: false
    },
    {
      id: 10,
      title: "Discovery Princess",
      // destination: "High-Sea Experience",
      cruiseLine: "Princess",
      // price: 699,
      imageUrl: princess5night,
        links:{

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=4-6&destinationtype=All&Ship=14718&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=4-6&destinationtype=All&Ship=14718&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=4-6&destinationtype=All&Ship=14718&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
      // isExclusive: false
    },
    {
      id: 11,
      title: "Ovation of the Seas",
      // destination: "High-Sea Experience",
      cruiseLine: "Royal Caribbean",
      // price: 699,
      imageUrl: royal5night,
        links:{

  
  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=4-6&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=4-6&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=4-6&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
      // isExclusive: false
    },
    {
      id: 12,
      title: "Navigator of the Seas",
      // destination: "High-Sea Experience",
      cruiseLine: "Royal Caribbean",
      // price: 699,
      imageUrl: royalnv5night,
        links:{

 
  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=4-6&destinationtype=All&Ship=81&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=4-6&destinationtype=All&Ship=81&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=4-6&destinationtype=All&Ship=81&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
      // isExclusive: false
    }
  ],
  "8-nights": [
    {
      id: 13,
      title: "Ovation of the Seas",
      // destination: "Multi-Country Explorer",
      cruiseLine: "Royal Caribbean",
      // price: 1299,
      imageUrl: royal8night,
        links:{

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&durations=7-9&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&durations=7-9&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&durations=7-9&destinationtype=All&Ship=13717&departureports=SIN&sortColumn=cruiselinePriority&sortOrder=asc"     
      }
      // isExclusive: false
    }
  ]
 
};

const Itineraries = () => {

   const currency = useContext(CurrencyContext);
  const [activeTab, setActiveTab] = useState("3-nights");

  return (
    <section id="itineraries" className="itineraries-section">
      <div className="container">
        <div className="header">
          <h2>Explore the Itineraries and Choose Your Cruise Now</h2>
          <p>Discover a variety of cruise durations to fit your schedule, from weekend getaways to extended voyages.</p>
        </div>
{/* 
     <div className="Itineraries-night-section">
      <div className="nonights">
       <a href={Linkdata.Nights2[currency.currencyCode]} target="_self" rel="noopener noreferrer"><button>2 Nights</button></a>
       <a href={Linkdata.Nights3[currency.currencyCode]} target="_self" rel="noopener noreferrer"><button>3 Nights</button></a>
       <a href={Linkdata.Nights5[currency.currencyCode]} target="_self" rel="noopener noreferrer"><button>5 Nights</button></a>
       <a href={Linkdata.Nights8[currency.currencyCode]} target="_self" rel="noopener noreferrer"><button>8 Nights</button></a>
      </div>
     </div> */}

        <div className="tabs">
          <div className="tabs-list">
            {Object.keys(itinerariesData).map((duration) => (
              <button
                key={duration}
                className={`tab-button ${activeTab === duration ? "active" : ""}`}
                onClick={() => setActiveTab(duration)}
              >
                {duration.replace("-", " ")} Cruise
              </button>
            ))}
          </div>

          <div className="tabs-content">
            <div className="card-grid">
              {itinerariesData[activeTab]?.map((item) => (
                <div className="card" key={item.id}> 
                  <div className="card-image">
                    <img src={item.imageUrl} alt={item.title} />
                    {/* <div className="label">{activeTab.replace("-", " ")}</div> */}
                    {/* {item.isExclusive && <div className="exclusive">Int2 Exclusive</div>} */}
                    {/* {item.savings && <div className="savings">{item.savings}</div>} */}
                  </div>
                  <div className="card-content">
                    <div className="card-title-price">
                      <h3>{item.title}</h3>
                      {/* <span className="price">${item.price}<span className="per-person">/person</span></span> */}
                    </div>
                    {/* <p className="destination">{item.destination}</p> */}
                    <p className="cruise-line">By {item.cruiseLine}</p>
                    <a href={item.links[currency.currencyCode]}  target="_self">
                    <button className="view-button">View Details</button>
                    </a>
                  </div> 
               </div> 
       ))} 
            </div> 
         </div> 

        {
             <div className="exclusive-offers">
          <h3>Limited Time Lowest Prices Only With Int2Cruises</h3>
          {/* <p>Discover limited-time deals with unbeatable value curated by Int2Cruises</p> */}
          <div className="badge-container">
            <Link to="/int2special-3night-singapore" > <span className="badge">3 Night Cruise</span></Link>
            <Link to="/int2special-4night-singapore" > <span className="badge">4 Night Cruise</span></Link>
          </div>
        </div> }


        <div className="intspecial-offer" >
          <div className="night3-ovation">
            <img src={special1} className="nightsimg" alt="int2special"></img>
            <div>
            <img src={royallogo}className="royallogo-offer" alt="int2cruises exclusive booking"></img>
            <h3>Ovation of the Seas</h3>
            <h4>3 Nights</h4>
            <h5> • Singapore • Malaysia • Singapore </h5>
             {/* <a href={Linkdata.Nights3[currency.currencyCode]} target="_self" rel="noopener noreferrer">      */}
            <Link to="/int2special-3night-singapore" ><button>Explore Now</button></Link>
            {/* </a> */}
            </div>
          </div>
           <div className="night4-ovation">
            <img src={special2} className="nightsimg" alt="singapore night "></img>
            <div>
            <img src={royallogo} className="royallogo-offer" alt="int2cruises exclusive booking"></img>
            <h3>Ovation of the Seas</h3>
            <h4>4 Nights</h4>
            <h5> • Singapore • Malaysia • Thailand • Singapore </h5>
             {/* <a href={Linkdata.Nights4[currency.currencyCode]} target="_self" rel="noopener noreferrer"> */}
            <Link to="/int2special-4night-singapore" ><button>Explore Now</button></Link>
            {/* </a> */}
            </div>
          </div>
        </div>

        </div>
      </div>
    </section>
  );
};

export default Itineraries;
